import { pushToDataLayer } from '@/utils/analytics/analytics';
import { useUserStore } from '@/stores/user';
import { useAccountStore } from '@/stores/account';

export function gaEvent(eventName, success = true, data = {}) {
    const userStore = useUserStore();
    const accountStore = useAccountStore();

    pushToDataLayer({
        event_name: eventName + (success ? '_success' : '_error'),
        interaction_type: eventName,
        ...(userStore.user?.uid && { user_id: userStore.user.uid }),
        ...(accountStore.account?.account_id && { account_id: accountStore.account.account_id }),
        ...data
    });
}